<script>
export default {
    data() {
        return {
        }
    },
    props: {
        isBusy: {
            type: Boolean,
            default(rawProp) {
                return rawProp.isBusy ? rawProp.isBusy : false;
            },
            required: false,
        },
        cssClasses: {
            type: [Array, String],
            default(rawProp) {
                return rawProp.cssClasses ? rawProp.cssClasses : null;
            },
            required: false,
        },
    },
    computed: {
        computedClasses() {
            let elementClasses = ['busy-element'];
            let component = this;
            if (component.cssClasses) {
                if (typeof component.cssClasses === 'string') {
                    elementClasses.push(component.cssClasses);
                } else if (Array.isArray(component.cssClasses)) {
                    elementClasses.push(...component.cssClasses);
                }
            }
            if (component.isBusy) {
                elementClasses.push('is-busy');
            }
            return elementClasses;
        }
    }
}
</script>
<template>
    <div :class="computedClasses">
        <slot></slot>
    </div>
</template>